import store from '../store/officialWebStore';
import gameInfoConfig from '@configs/officialWebStore/globalGameInfoConfig';
import { pageType, viewPage } from '@plugins/biPoint/_configWebstoreV2';

const checkGameAndLogin = () => {
  const gameId = store.state.gameId;
  return store.state.login.isLogin && gameInfoConfig[gameId];
};

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      pageName: pageType.homePage
    },
    component: () => import('@views/officialWebStore/Home.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.homePage);
      next();
    }
  },
  {
    path: '/result',
    name: 'result',
    meta: {
      pageName: pageType.resultPage
    },
    component: () => import('@views/officialWebStore/Result.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.resultPage);
      next();
    }
  },
  {
    path: '/vip_score',
    name: 'vipScore',
    meta: {
      pageName: pageType.vipPage
    },
    component: () => import('@views/officialWebStore/VipPage.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.vipPage);
      next();
    }
  },
  {
    path: '/bank_info',
    name: 'bankInfo',
    meta: {
      index: 3,
      pageName: pageType.bankPage
    },
    component: () => import('@views/officialWebStore/BankDetailInfo.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.bankPage);
      next();
    }
  },
  {
    path: '/wallet',
    name: 'wallet',
    meta: {
      pageName: pageType.balancePage
    },
    component: () => import('@views/officialWebStore/Wallet.vue'),
    beforeEnter: (_to, _from, next) => {
      if (checkGameAndLogin()) {
        viewPage(pageType.balancePage);
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/browserPay',
    name: 'browserPay',
    meta: {
      pageName: pageType.browserPay
    },
    component: () => import('@views/officialWebStore/BrowserPaying.vue'),
    beforeEnter: (_to, _from, next) => {
      viewPage(pageType.browserPay);
      next();
    }
  }
];
